(function() {
	'use strict';
	angular.module('quantixApp').controller('CustomFilterController',
    CustomFilterController);
    CustomFilterController.$inject = [ '$scope','$uibModalInstance'];
	function CustomFilterController($scope,$uibModalInstance, message) {
        $scope.clear = function() {
			$uibModalInstance.dismiss('cancel');
        }
       
	}

})();